// themeConfig.ts

export const customThemes = {
  light: {
    siderBg: '#001529',
    headerBg: '#f0f2f5',
    layoutBg: '#f0f2f5',
    contentBg: '#ffffff',
    contentText: '#141414',
    footerBg: '#f0f2f5',
    colorPrimary: '#07243c',
  },
  dark: {
    siderBg: '#1f1f1f',
    headerBg: '#1f1f1f',
    layoutBg: '#141414',
    contentBg: '#141414',
    contentText: '#ffffff',
    footerBg: '#1f1f1f',
    colorPrimary: '#f1f1f1',
  },
};
